<template>
  <modal
    :title="modalTitle"
    :show.sync="showing"
    @cancel="closeModal"
    :large="true"
  >
    <div>
      <loading-alert v-if="loading"></loading-alert>

      <form
        v-show="!loading && !hasError"
        @submit.prevent="submit()"
        autocomplete="off"
      >
        <div class="t-bg-white t-rounded t-px-8 t-pt-6 t-pb-8">
          <div class="md:t-flex md:t-items-center t-mb-6">
            <div class="md:t-w-1/3">
              <label
                class="t-block t-text-gray-500 t-font-bold md:t-text-right md:t-mb-0 t-pr-4"
                >Name (*)</label
              >
            </div>
            <div class="md:t-w-2/3">
              <input
                v-model="form.name"
                :class="{ 'is-invalid': errors.has('name') }"
                v-validate="'required'"
                name="name"
                class="t-block t-appearance-none t-w-2/3 t-bg-gray-200 t-border t-border-gray-200 t-text-gray-700 t-py-3 t-px-4 t-pr-8 t-rounded t-leading-tight focus:t-outline-none focus:t-bg-white focus:t-border-gray-500"
                type="text"
              />
              <div v-show="errors.has('name')" class="t-text-red-700 t-text-sm">
                Please enter a name
              </div>
            </div>
          </div>

          <div class="md:t-flex md:t-items-center t-mb-6">
            <div class="md:t-w-1/3">
              <label
                class="t-block t-text-gray-500 t-font-bold md:t-text-right md:t-mb-0 t-pr-4"
                >Trucks</label
              >
            </div>
            <div class="md:t-w-2/3">
              <multiselect
                v-model="form.trucks"
                :multiple="true"
                :options="trucks"
                :custom-label="nameWithLang"
                track-by="id"
                placeholder="Select trucks"
                label="trucks"
                :close-on-select="false"
              >
              </multiselect>
              <div
                v-show="errors.has('trucks')"
                class="t-text-red-700 t-text-sm"
              >
                Please select some trucks
              </div>
            </div>
          </div>
        </div>

        <div class="t-flex t-items-center t-justify-end t-pt-4">
          <button
            @click="closeModal"
            type="button"
            class="t-bg-gray-500 hover:t-bg-gray-700 t-text-white t-font-bold t-py-2 t-px-4 t-my-4 t-rounded focus:t-outline-none focus:t-shadow-outline"
            data-dismiss="modal"
          >
            Close
          </button>
          <button
            :disabled="saving"
            type="submit"
            class="t-bg-green-500 hover:t-bg-green-700 t-text-white t-font-bold t-py-2 t-px-4 t-mx-4 t-my-4 t-rounded focus:t-outline-none focus:t-shadow-outline"
          >
            <i v-if="saving" class="fa fa-spinner fa-spin"></i>
            <span v-else>{{ buttonText }}</span>
          </button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import Modal from "../../utils/Modal_v2";
import LoadingAlert from "../../utils/LoadingAlert";
import Multiselect from "vue-multiselect";

export default {
  name: "fleets-form",
  components: {
    Modal,
    LoadingAlert,
    Multiselect
  },
  props: ["showing", "fleet"],
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      loading: true,
      saving: false,
      hasError: null,
      types: [],
      form: {
        name: "",
        trucks: []
      },
      trucks: []
    };
  },

  mounted() {
    if (this.fleet) {
      this.form.name = this.fleet.name;
      this.form.trucks = this.fleet.trucks;
    }

    this.loadTrucks();
  },

  methods: {
    loadTrucks() {
      this.loading = true;

      api.get("/carrier/gps/trucks").then(response => {
        this.loading = false;
        this.trucks = response.data.data;
      });
    },

    nameWithLang({ plate, display_name }) {
      return `${plate} — [${display_name}]`;
    },

    closeModal() {
      this.$emit("cancelled");
    },

    submit() {
      this.saving = true;

      if (this.fleet) {
        api
          .patch("/carrier/gps/fleets/" + this.fleet.id, {
            name: this.form.name,
            trucks: this.form.trucks.map(truck => truck.id)
          })
          .then(response => {
            this.$emit("submitted", response);
          })
          .catch(error => {
            this.$emit("error");
            this.saving = false;
          });
      } else {
        api
          .post("/carrier/gps/fleets", {
            name: this.form.name,
            trucks: this.form.trucks.map(truck => truck.id)
          })
          .then(response => {
            this.$emit("submitted", response);
          })
          .catch(error => {
            this.$emit("error");
            this.saving = false;
          });
      }
    }
  },

  computed: {
    modalTitle() {
      if (this.fleet) {
        return "Editing: " + this.fleet.name;
      }

      return "Create fleet";
    },

    buttonText() {
      if (this.fleet) {
        return "Update";
      }

      return "Create";
    }
  }
};
</script>
